import React from "react";
import food_img from "./../../Media/main/food.svg";
import delivery from "./../../Media/main/delivery.svg";
import "./Main.css";
import { Link } from "react-router-dom";

const Main = () => {
  return (
    <div className="main padding">
      <div className="main__content">
        <section className="about">
          <div className="about__item">
            <div className="about__text">
              <h3 className="about__title">The Best Fast-Food Ever</h3>
              <p className="about__desc">
                our website has the best food experts and they are responsible
                on creating the best food using the the most clean and modern
                way, our resturant collect the best food matieral and they spend
                hous testing the best test that you can get
              </p>
            </div>
            <div className="about__img--container">
              <img className="about__img" src={food_img} alt="food" />
            </div>
          </div>

          <div className="about__item">
            <div className="about__img--container">
              <img className="about__img" src={delivery} alt="food" />
            </div>
            <div className="about__text">
              <h3 className="about__title">The Best Fast-Food Ever</h3>
              <p className="about__desc">
                our website has the best food experts and they are responsible
                on creating the best food using the the most clean and modern
                way, in your home and on your bed you can order your faviourt
                food and we will take the rest of work we have to fastest food
                delivery service that will bring the food for you.
              </p>
            </div>
          </div>
        </section>

        <section className="order padding">
          <h2 className="section__title">What Are You Wating For?</h2>
          <Link to="/signup" className="order__now link">
            Order Now
          </Link>
        </section>
      </div>
    </div>
  );
};

export default Main;
